module.exports = __webpack_public_path__ + "static/img/m_name.ffed2d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/yzzzbq/m_name.png
// module id = D7Xf
// module chunks = 7